"use strict";

require("core-js/modules/es.object.define-property.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _SvgIcon = _interopRequireDefault(require("@material-ui/core/SvgIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var SvgLabel = function SvgLabel(props) {
  return /*#__PURE__*/_react["default"].createElement(_SvgIcon["default"], props, /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("style", null, '.label_svg__cls-1{fill:#333}')), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M22.41 11.58l-9-9A2 2 0 0012 2H5a2 2 0 00-2 2v7a2 2 0 00.59 1.42l9 9A2 2 0 0014 22a2 2 0 001.41-.59l7-7A2 2 0 0023 13a2 2 0 00-.59-1.42zM14 20l-9-9V4h7l9 9z"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    className: "label_svg__cls-1",
    cx: 7.5,
    cy: 6.5,
    r: 1.5
  }), /*#__PURE__*/_react["default"].createElement("path", {
    transform: "rotate(-45 16.203 11.209)",
    d: "M15.46 8.24h1.5v5.93h-1.5z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    transform: "rotate(-45 14.2 13.208)",
    d: "M13.46 10.24h1.5v5.93h-1.5z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    transform: "rotate(-45 11.164 14.156)",
    d: "M10.41 12.68h1.5v2.97h-1.5z"
  }));
};

var _default = SvgLabel;
exports["default"] = _default;